<app-view
  [justify]="ViewJustify.END"
  [spacingBottom]="Spacing.MEDIUM"
  [gap]="Spacing.MEDIUM_SMALL"
>
  @if (adminUserService.hasPermission(UserPermission.READ_USER_INVITE)){ @if
  (filteredUsers().length > 0){
  <app-button
    [type]="ButtonType.GHOST"
    (handleClick)="handleDownloadEmails()"
    [spacingBottom]="Spacing.NONE"
    data-test-id="download-users-button"
    >Download Users</app-button
  >
  }
  <app-button
    [type]="ButtonType.PRIMARY"
    (handleClick)="handleInviteUsersDialog()"
    [spacingBottom]="Spacing.NONE"
    data-test-id="users-invite-users-button"
    >Invite Users</app-button
  >
  }
</app-view>
<div class="users-filter">
  <app-heading titleLevel="3" spacingBottom="16">{{
    'users.users' | translate
  }}</app-heading>
  <app-text-input
    id="searchText"
    [type]="InputType.SEARCH"
    [size]="InputSize.SMALL"
    [(value)]="searchInput"
    [disabled]="isLoading()"
    placeholder="{{ 'common.search' | translate }}"
    data-test-id="users-search-input"
  />
</div>
<div class="status-filter-bar" data-test-id="users-status-filter">
  @for (option of statusOptions; track option.value) {
    <button
      class="status-filter-btn"
      [class.active]="statusFilter() === option.value"
      (click)="setStatusFilter(option.value)"
    >
      {{ option.label | translate }}
    </button>
  }
</div>
<div class="users-container">
  @if (isLoading()) {
  <app-spinner data-test-id="users-spinner"></app-spinner>
  } @else {
  <app-table
    [tableData]="filteredUsers()"
    [config]="tableConfig"
    (handleOptionSelected)="onOptionSelected($event)"
    data-test-id="users-table"
  ></app-table>
  @if (!filteredUsers().length) {
  <p data-test-id="users-no-users-message">{{ 'users.noUsers' | translate }}</p>
  } }
</div>

<app-add-users-dialog
  [(isOpen)]="inviteUsersDialogOpen"
  data-test-id="users-invite-users-dialog"
>
</app-add-users-dialog>

<app-confirm-dialog
  [(isOpen)]="dialogOpen"
  [title]="
    'client.removeUserDialogText'
      | translate : { name: selectedUser?.name || '' }
  "
  [subTitle]="'client.removeUserDialogSubText' | translate"
  [primaryText]="'client.removeUserDialogConfirmLabel' | translate"
  [secondaryText]="'client.removeUserDialogCancelLabel' | translate"
  [headerPlacement]="ViewAlign.CENTER"
  [headerGap]="Spacing.SMALL"
  (handlePrimaryButton)="removeUser()"
  (handleSecondaryButton)="closeDialog()"
  [titleAlignment]="TextAlign.CENTER"
  data-test-id="users-confirm-dialog"
></app-confirm-dialog>
